<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :btnEditVisible="true" :linkedit="linkedit" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="outline-success btn-toolbar sa-margin-right" size="sm" @click="onClickAssocia">
                <b-icon icon="people-fill"></b-icon>
                Associa Utente
            </b-button>
        </template>
        <template slot="table-filter"> </template>
        <template slot="table-body">
            <strutture-presidi-view-component ref="StrutturePresidiViewComponent" :showModalLoading="showModalLoading" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" @usersLoaded="onUsersLoaded"></strutture-presidi-view-component>
            <associa-utenti-presidi-modal-component ref="cmpAssocciaUtentiModal" @afterLoadData="onAfterLoadData" :associated-users="associatedUsers"></associa-utenti-presidi-modal-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import StrutturePresidiViewComponent from "../components/StrutturePresidiViewComponent.vue";
import AssociaUtentiPresidiModalComponent from "../components/AssociaUtentiPresidiModalComponent.vue";
export default {
    components: { SaPageLayout, StrutturePresidiViewComponent, AssociaUtentiPresidiModalComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "",
            linkback: "/strutturapresidi",
            pathResourceUtenti: "/users",
            pathResourceGruppiUtenti: "/gruppi",
            linkedit: null,
            jsonData: {},
            mdlFiltroUsers: {},
            associatedUsers: [],
        };
    },
    mounted: function () {
        let me = this;
        me.id = this.$route.params.id;
        me.linkedit = "/strutturapresidi/edit/" + me.id;
        //me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.StrutturePresidiViewComponent.loadData();
        },
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {},
        onUsersLoaded(users) {
            let me = this;
            me.associatedUsers = users;
        },
        onClickAssocia() {
            let me = this;
            me.$refs.cmpAssocciaUtentiModal.show();
        },
        onAfterLoadData() {
            let me = this;
            me.loadData();
        },
    },
};
</script>

<style></style>
